'use strict';

import { EnvironmentLayer } from './EnvironmentLayer';

export class RoadsEnvironment extends EnvironmentLayer{
    constructor () {
        super('Highway');
        // this.roadsEffect = new RoadsAdditionalEffect();
        this.animateCamera = true;
    }

    show() {
        this.active = true;
        this.create();
        this.group.visible = true;
        EnvironmentLayer.animateCameraShow();
    }

    create() {
        // this.roadsEffect.enable().then(() => {
            this.objects.forEach(obj => this.buildRoute(obj));
        // });
    }
    
    hide() {
        this.active = false;
        this.group.visible = false;
        this.clear();
        // this.roadsEffect.disable();
        EnvironmentLayer.animateCameraHide();
    }

    intersect(obj) {
    }

}


// export class RoadsAdditionalEffect {
//     constructor () {
//         this.controls = threeJsVariables.orbitControls;
//         this.renderer = threeJsVariables.renderer;
//         this.params = {
//             bloomDefaultConfig: {},
//             bloomActiveConfig: {
//                 strength: 0.8,
//                 radius: -1,
//                 threshold: 0.81,
//                 enabled: true
//             }
//         };
//     }
//
//     enable() {
//         const mixer = GSAPAnimationMixer.registerNewMixer('roadsCamera');
//         const angle = getPolarAngleFromViewMode(ViewMode.Orbit);
//         const polarAngle = {value: angle.maxAngle};
//         const toneMapping = {value: this.renderer.toneMappingExposure};
//
//         const polarAngleAnimation = gsap.to(polarAngle,{
//             value: (angle.minAngle + angle.maxAngle) / 2,
//             duration: GSAPAnimationMixer.duration,
//             ease: GSAPAnimationMixer.ease,
//             onUpdate: () => {
//                 this.controls.maxPolarAngle = polarAngle.value;
//             }
//         });
//
//         const toneMappingAnimation = gsap.to(toneMapping,{
//             value: 0.5,
//             duration: GSAPAnimationMixer.duration,
//             ease: GSAPAnimationMixer.ease,
//             onUpdate: () => {
//                 this.renderer.toneMappingExposure = toneMapping.value;
//             }
//         });
//
//         mixer.addAnimation(polarAngleAnimation);
//         mixer.addAnimation(toneMappingAnimation);
//
//         return new Promise(resolve => {
//             mixer.addCallback('onComplete',() => {
//                 this.applyBloom(true);
//                 resolve();
//             });
//             mixer.play();
//         });
//     }
//
//     disable() {
//         const mixer = GSAPAnimationMixer.registerNewMixer('roadsCamera');
//         const angle = getPolarAngleFromViewMode(ViewMode.Orbit);
//         const polarAngle = {value: this.controls.getPolarAngle()};
//         const toneMapping = {value: this.renderer.toneMappingExposure};
//         this.applyBloom(false);
//
//         const polarAngleAnimation = gsap.to(polarAngle,{
//             value: angle.maxAngle,
//             duration: GSAPAnimationMixer.duration,
//             ease: GSAPAnimationMixer.ease,
//             onUpdate: () => {
//                 this.controls.maxPolarAngle = polarAngle.value;
//                 this.controls.setPolarAngle(polarAngle.value);
//             }
//         });
//
//         const toneMappingAnimation = gsap.to(toneMapping,{
//             value: 1,
//             duration: GSAPAnimationMixer.duration,
//             ease: GSAPAnimationMixer.ease,
//             onUpdate: () => {
//                 this.renderer.toneMappingExposure = toneMapping.value;
//             }
//         });
//
//         mixer.addAnimation(polarAngleAnimation);
//         mixer.addAnimation(toneMappingAnimation);
//
//         return new Promise(resolve => {
//             mixer.addCallback('onComplete',() => resolve());
//             mixer.play();
//         });
//     }
//
//     applyBloom(state) {
//         const bloom = threeJsVariables.composer.getPass('bloom');
//         if (!bloom) return;
//
//         if (state) {
//             this.params.bloomDefaultConfig = bloom.config;
//             bloom.config = this.params.bloomActiveConfig;
//         } else {
//             bloom.config = this.params.bloomDefaultConfig;
//         }
//     }
//
// }